import { tv } from "../../variants/tv.js";
const typeVariants = {
    customer: 'text-customer-8',
    neutral: 'text-neutral-8',
    neutralSecondary: 'text-neutral-10',
    priceRetail: 'text-priceRetail-8',
    priceSale: 'text-priceSale-8',
    priceSecondary: 'text-priceRetail-13',
    priceTertiary: 'text-priceSale-10',
    socHighlight: 'text-priceSale-11',
    socSavings: 'text-priceSale-12',
    urgency: 'text-urgency-8'
};
const textStyleVariants = {
    body1: 'text-body1 font-medium',
    body2: 'text-body2 font-medium',
    body3: 'text-body3 font-medium',
    heading1: 'text-heading1 font-bold',
    heading2: 'text-heading2 font-bold',
    heading3: 'text-heading3 font-bold',
    heading4: 'text-heading4 font-bold',
    heading5: 'text-heading5 font-bold',
    heading6: 'text-heading6 font-bold',
    '2xsHeading4to3': 'text-heading4 font-bold @2xs:text-heading3',
    '2xsBody3to2': 'text-body3 font-medium @2xs:text-body2'
};
const emphasisVariants = {
    regular: '',
    bold: ''
};
const priceTypes = Object.keys(typeVariants);
const priceTextStyles = Object.keys(textStyleVariants);
const priceEmphases = Object.keys(emphasisVariants);
const isFormattedVariants = {
    true: ''
};
const boldVariants = {
    true: 'font-bold'
};
const isStrikeVariants = {
    true: ''
};
const priceSlots = {
    currencyCodeSlot: '',
    currencySymbolSlot: '',
    priceSlot: 'relative flex items-center',
    priceWholeSlot: '',
    priceDecimalSlot: '',
    priceStrikeSlot: 'absolute right-0 w-[100%] top-[40%] transform skew-y-[-10deg] text-urgency-8 rounded-full',
    prefixSlot: '',
    suffixSlot: 'whitespace-pre'
};
const isFormattedCompoundVariants = [
    {
        textStyle: 'heading1',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-heading1 self-start',
            currencySymbolSlot: 'text-priceSuper-heading1 self-start',
            priceDecimalSlot: 'text-priceSuper-heading1 self-start',
            suffixSlot: 'text-priceSub-heading1 self-end'
        }
    },
    {
        textStyle: 'heading2',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-heading2 self-start',
            currencySymbolSlot: 'text-priceSuper-heading2 self-start',
            priceDecimalSlot: 'text-priceSuper-heading2 self-start',
            suffixSlot: 'text-priceSub-heading2 self-end'
        }
    },
    {
        textStyle: 'heading3',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-heading3 self-start',
            currencySymbolSlot: 'text-priceSuper-heading3 self-start',
            priceDecimalSlot: 'text-priceSuper-heading3 self-start',
            suffixSlot: 'text-priceSub-heading3 self-end'
        }
    },
    {
        textStyle: 'heading4',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-heading4 self-start',
            currencySymbolSlot: 'text-priceSuper-heading4 self-start',
            priceDecimalSlot: 'text-priceSuper-heading4 self-start',
            suffixSlot: 'text-priceSub-heading4 self-end'
        }
    },
    {
        textStyle: 'heading5',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-heading5 self-start',
            currencySymbolSlot: 'text-priceSuper-heading5 self-start',
            priceDecimalSlot: 'text-priceSuper-heading5 self-start',
            suffixSlot: 'text-priceSub-heading5 self-end'
        }
    },
    {
        textStyle: 'heading6',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-heading6 self-start',
            currencySymbolSlot: 'text-priceSuper-heading6 self-start',
            priceDecimalSlot: 'text-priceSuper-heading6 self-start',
            suffixSlot: 'text-priceSub-heading6 self-end'
        }
    },
    {
        textStyle: 'body1',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-body1 self-start',
            currencySymbolSlot: 'text-priceSuper-body1 self-start',
            priceDecimalSlot: 'text-priceSuper-body1 self-start',
            suffixSlot: 'text-priceSub-body1 self-end'
        }
    },
    {
        textStyle: 'body2',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-body2 self-start',
            currencySymbolSlot: 'text-priceSuper-body2 self-start',
            priceDecimalSlot: 'text-priceSuper-body2 self-start',
            suffixSlot: 'text-priceSub-body2 self-end'
        }
    },
    {
        textStyle: 'body3',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-body3 self-start',
            currencySymbolSlot: 'text-priceSuper-body3 self-start',
            priceDecimalSlot: 'text-priceSuper-body3 self-start',
            suffixSlot: 'text-priceSub-body3 self-end'
        }
    },
    {
        textStyle: '2xsHeading4to3',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-heading4 self-start @2xs:text-priceSuper-heading3',
            currencySymbolSlot: 'text-priceSuper-heading4 self-start @2xs:text-priceSuper-heading3',
            priceDecimalSlot: 'text-priceSuper-heading4 self-start @2xs:text-priceSuper-heading3',
            suffixSlot: 'text-priceSub-heading4 self-end @2xs:text-priceSub-heading3'
        }
    },
    {
        textStyle: '2xsBody3to2',
        isFormatted: true,
        class: {
            currencyCodeSlot: 'text-priceSuper-body3 self-start @2xs:text-priceSuper-body2',
            currencySymbolSlot: 'text-priceSuper-body3 self-start @2xs:text-priceSuper-body2',
            priceDecimalSlot: 'text-priceSuper-body3 self-start @2xs:text-priceSuper-body2',
            suffixSlot: 'text-priceSub-body3 self-end @2xs:text-priceSub-body2'
        }
    }
];
const isEmphasisCompoundVariants = [
    {
        type: 'neutral',
        emphasis: 'bold',
        class: {
            base: 'text-priceRetail-1'
        }
    },
    {
        type: 'neutralSecondary',
        emphasis: 'bold',
        class: {
            base: 'text-priceRetail-6'
        }
    },
    {
        type: 'priceRetail',
        emphasis: 'bold',
        class: {
            base: 'text-priceRetail-1'
        }
    },
    {
        type: 'priceSale',
        emphasis: 'bold',
        class: {
            base: 'text-priceSale-7'
        }
    },
    {
        type: 'priceSecondary',
        emphasis: 'bold',
        class: {
            base: 'text-priceRetail-1'
        }
    },
    {
        type: 'priceTertiary',
        emphasis: 'bold',
        class: {
            base: 'text-priceSale-6'
        }
    },
    {
        type: 'socHighlight',
        emphasis: 'bold',
        class: {
            base: 'text-priceSale-7'
        }
    },
    {
        type: 'socSavings',
        emphasis: 'bold',
        class: {
            base: 'text-priceSale-1'
        }
    },
    {
        type: 'urgency',
        emphasis: 'bold',
        class: {
            base: 'text-urgency-7'
        }
    }
];
const isStrikeCompoundVariants = [
    {
        textStyle: 'heading1',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-4'
        }
    },
    {
        textStyle: 'heading2',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-3'
        }
    },
    {
        textStyle: 'heading3',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-[2.5px]'
        }
    },
    {
        textStyle: 'heading4',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2'
        }
    },
    {
        textStyle: 'heading5',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2'
        }
    },
    {
        textStyle: 'heading6',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2'
        }
    },
    {
        textStyle: 'body1',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2'
        }
    },
    {
        textStyle: 'body2',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2'
        }
    },
    {
        textStyle: 'body3',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2'
        }
    },
    {
        textStyle: '2xsHeading4to3',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2 @2xs:border-b-[2.5px]'
        }
    },
    {
        textStyle: '2xsBody3to2',
        isStrike: true,
        class: {
            priceStrikeSlot: 'border-b-2'
        }
    }
];
const priceCompoundVariants = [
    ...isFormattedCompoundVariants,
    ...isEmphasisCompoundVariants,
    ...isStrikeCompoundVariants
];
const priceDefaultVariants = {
    type: 'neutral',
    textStyle: 'body1',
    isFormatted: false,
    bold: false,
    emphasis: 'regular',
    isStrike: false
};
const priceVariants = tv({
    base: 'flex items-center self-center',
    variants: {
        type: typeVariants,
        textStyle: textStyleVariants,
        emphasis: emphasisVariants,
        isFormatted: isFormattedVariants,
        bold: boldVariants,
        isStrike: isStrikeVariants
    },
    slots: priceSlots,
    compoundVariants: priceCompoundVariants,
    defaultVariants: priceDefaultVariants
});
export { priceEmphases, priceTextStyles, priceTypes, priceVariants };
